import { add } from "date-fns";

const { REACT_APP_SYSTEM_ROLES } = process.env;
export const readWriteValue = {
  read: 1,
  write: 2,
  none: 0,
};

export const canAccessfolderTypes = {
  folder: 1,
  document: 2,
  addressBook: 3,
  Journal: 4,
  photos: 11,
  cart: 5,
  home: 6,
  none: 0,
};
export const projectType = {
  property: 0,
  occupant: 1,
  level: 2,
};

export const userAccessType = {
  none: 0,
  read: 1,
  write: 2,
};

export const tenantData = JSON.parse(REACT_APP_SYSTEM_ROLES);

export const allFolderType = {
  Folder: 1,
  Document: 2,
  Journal: 4,
  Address_Book: 3,
  Info: 7,
  Photos: 11,
};

export const jobTypes = {
  ADDFILE: "addFile",
  EDITFILE: "editFile",
  DELETEFILE: "deleteFile",
  ADDJOURNAL: "addJournal",
  EDITJOURNAL: "editJournal",
  DELETEJOURNAL: "deleteJournal",
};

export const queryTypes = {
  file: "file",
  journal: "journal",
  addressBook: "addressbook",
};

export const InteractiveSearchUIMessage = {
  USER_GREETING: "Hello! How can I assist you with your search today?",
  NO_RESULTS: "I'm sorry, but I couldn't find any results matching your query.",
  ERROR_MESSAGE: "Oops! Something went wrong. Please try again later.",
};
